module.exports = __webpack_public_path__ + "static/img/banner-3.4070e03.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner-3.png
// module id = s8g6
// module chunks = 1